/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {Fragment} from "react";
import {Col} from "react-bootstrap";
import Tile from "./Tile";

export const TileWithDetailComponent = (props) => {
    const {
        item,
        xs, sm, md, lg,
        colSize = 4,
        ellipsis,
        noIcon,
        showComplete,
        onClick,
        actions,
        url,
        subtitle,
        caption,
        tileDetailComponent: TileDetailComponent,
    } = props
    
    return <Fragment>
        <Col
            className={TileDetailComponent ? 'pr-0 tile-list-column' : "tile-list-column"}
            xs={xs ?? colSize}
            sm={sm ?? xs ?? colSize}
            md={md ?? sm ?? colSize}
            lg={lg ?? md ?? colSize}
        >
            <Tile
                item={item}
                caption={caption}
                subtitle={subtitle}
                actions={actions}
                ellipsis={ellipsis}
                url={url}
                onClick={() => onClick ? onClick(item) : null}
                noIcon={noIcon}
                showComplete={showComplete}
            />
        </Col>
        {
            TileDetailComponent &&
            <Col xs={12 - colSize} className="tile-details">
                <TileDetailComponent item={item}/>
            </Col>
        }
    </Fragment>
}
